import { T as W, j as a, c as X, i as $, r as q, n as S, X as k, K as u } from "./index-2269cfe0.js";
import R from "react";
import { Box as m } from "./box.mjs";
import { L as M, a as j } from "./LoadingSpinnerIcon-943ea1b3.js";
import { r as f, c as b } from "./polished.esm-7edc4d30.js";
import { css as t } from "styled-components";
import { c as P } from "./WCLComponent.styles-68ac5b1f.js";
import { E as F } from "./ErrorBoundary-60d80e23.js";
import "react-inlinesvg";
const H = `
  font-family: Calibre-R;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  user-select: none;
`, V = (o) => {
  switch (o) {
    case "white":
      return t`
        color: ${u};
        background-color: transparent;
        border: 1px solid ${u};

        &:focus {
          border: 1px solid ${u};
          background-color: ${f(u, 0.08)};
        }

        &:focus-visible {
          box-shadow: 0 0 0 1px ${$};
        }

        &:hover,
        &:active {
          color: ${u};
          background-color: ${f(u, 0.08)};
        }
      `;
    case "black":
      return t`
        color: ${k};
        background-color: ${u};
        border: 1px solid ${u};

        &:focus {
          border: 1px solid ${u};
          background-color: #666;
        }

        &:focus-visible {
          box-shadow: 0 0 0 1px ${$};
        }

        &:hover,
        &:active {
          color: ${k};
          background-color: #666;
        }
      `;
  }
}, Y = (o, e, n) => {
  if (e === "text" || e === "inline")
    return t`
      color: ${({ theme: r }) => r.colors.interface};
      background-color: transparent;
    `;
  switch (o) {
    case "primary":
      return t`
        color: ${({ theme: r }) => r.colors.white};
        background-color: ${({ theme: r }) => r.colors.interface};
        border: 1px solid ${({ theme: r }) => r.colors.interface};

        &:focus {
          border-color: transparent;
          background-color: ${({ theme: r }) => b(0.03)(r.colors.interface)};
        }

        &:focus-visible {
          box-shadow: 0 0 0 2px ${$};
        }

        &:hover,
        &:active {
          color: ${({ theme: r }) => r.colors.white};
          background-color: ${({ theme: r }) => b(0.03)(r.colors.interface)};
        }
      `;
    case "secondary":
      return t`
        color: ${({ theme: r }) => r.colors.interface};
        background-color: transparent;
        border: 1px solid ${({ theme: r }) => r.colors.interface};

        &:focus {
          border: 1px solid ${({ theme: r }) => r.colors.interface};
          background-color: ${({ theme: r }) => f(r.colors.interface, 0.08)};
        }

        &:focus-visible {
          box-shadow: 0 0 0 2px ${$};
        }

        &:hover,
        &:active {
          color: ${({ theme: r }) => r.colors.interface};
          background-color: ${({ theme: r }) => f(r.colors.interface, 0.08)};
        }
      `;
    case "tertiary":
      return V(n);
  }
}, A = (o) => {
  const e = t`
    cursor: pointer;

    &[disabled] {
      cursor: default;
      pointer-events: none;
      background-color: transparent;
      color: ${f(q, 0.5)};
    }
  `, n = t`
    ${e}

    &[disabled] {
      border: 1px solid ${S};
    }
  `;
  switch (o) {
    case "square":
      return t`
        border-radius: 4px;
        ${n}
      `;
    case "pill":
      return t`
        border-radius: 16px;
        ${n};
      `;
    case "text":
      return t`
        border-radius: 4px;
        &:focus {
          background-color: ${({ theme: r }) => r.colors.lightestGrey};
        }

        &:focus-visible {
          box-shadow: 0 0 0 2px ${$};
        }

        &:hover,
        &:active {
          color: ${({ theme: r }) => r.colors.interface};
          background-color: ${({ theme: r }) => f(r.colors.interface, 0.08)};
        }
        ${e}
      `;
    case "inline":
      return t`
        display: inline-flex;
        font-size: inherit;
        &:hover,
        &:active {
          color: ${({ theme: r }) => r.colors.interface};
          background-color: transparent;
          border-color: none;
          text-decoration: underline;
        }
        ${e}
      `;
    case "pagination":
      return t``;
  }
}, z = `
 cursor: pointer;
 width: 35px;
 height: 35px;
 flex-grow: 0;
 object-fit: contain;
 border-radius: 27px;
 border: solid 1px #bfbfbf;
 background-color: #fff;
 padding: 0px;

 &:hover, &:focus {
   box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
 }

 &:focus-visible {
   outline: solid 2px ${u};
 }
`, J = (o) => o ? t`
      ${z}
      cursor: default;
      pointer-events: none;
      background-color: transparent;
      border: solid 1px ${S};
      * {
        stroke: ${S};
      }
    ` : t`
    ${z}
  `, N = (o, e, n, r) => {
  const i = (c) => c === "tertiary" ? "0.75rem 1.5rem" : "0.875rem 1.5rem";
  switch (o) {
    case "small":
      return `
        ${e === "inline" ? "" : "padding: 0.375rem 1.5rem"};
        ${r ? "padding: 0.375rem 0.75rem" : ""}
        font-size: 0.75rem;
        line-height: 1.67;
    `;
    case "large":
      return `
        ${e === "inline" ? "" : `padding: ${i(n)}`};
        font-size: 1rem;
        line-height: 1.5;
    `;
  }
}, O = (o, e) => {
  let n = "";
  const r = t`
    cursor: pointer;
    color: ${({ theme: i }) => i.colors.white};
    background-image: linear-gradient(to top, ${({ theme: i }) => i.colors.interface}, #6b49f4);
    box-shadow: 0 6px 8px 0 rgba(26, 21, 255, 0.21);

    &[disabled] {
      cursor: default;
      pointer-events: none;
      box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.12), 0 0 4px 0 rgba(0, 0, 0, 0.24);
      color: ${({ theme: i }) => i.colors.darkGrey};
      background-color: ${({ theme: i }) => i.colors.disabledGrey};
      background-image: none;

      & > span {
        opacity: 50%;
      }
    }
  `;
  if (e ? n = `
      height: 3rem;
      font-size: 1rem;
      line-height: 1.5;
      border-radius: 200px;
    ` : n = t`
      height: 4rem;
      font-size: 1.25rem;
      line-height: 1.2;
      border-radius: 60px;

      &:focus-visible {
        border: 2px solid ${$};
      }

      &:hover,
      &:active {
        background-image: none;
        background-color: ${({ theme: i }) => b(0.03)(i.colors.interface)};
      }
    `, o)
    return t`
      ${r}
      ${n}
    `;
}, B = (o) => {
  if (o)
    return `
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    `;
}, w = (o) => t`
    position: relative;
    overflow: hidden;

    & > span.ripple {
      position: absolute;
      border-radius: 50%;
      transform: scale(0);
      background-color: ${o};

      animation-duration: 1.2s;
      animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      animation-name: ripple;
    }

    @keyframes ripple {
      to {
        transform: scale(4);
        opacity: 0;
      }
    }
  `, C = (o, e, n, r) => {
  if (n)
    return t`
      ${({ theme: s }) => w(f(b(0.5)(s.colors.interface), 0.4))}
    `;
  if (e === "text")
    return t`
      ${({ theme: s }) => w(b(0.17)(s.colors.interface))}

      &:active {
        background-color: ${({ theme: s }) => s.colors.lightestGrey};
      }
    `;
  let i = "", c = "";
  switch (o) {
    case "primary":
      i = t`
        ${({ theme: s }) => f(b(0.5)(s.colors.interface), 0.4)}
      `;
      break;
    case "secondary":
      i = t`
        ${({ theme: s }) => f(b(0.17)(s.colors.interface), 0.4)}
      `;
      break;
    case "tertiary":
      c = r === "white" ? u : k, i = t`
        ${f(b(0.4)(c), 0.4)}
      `;
      break;
  }
  return t`
    ${w(i)}
  `;
}, Q = (o, e, n, r, i) => {
  if (!o)
    return;
  const c = (d) => `
    svg {
      height: 100%;
      width: 100%;
    }

    svg > path {
      color: ${d};
      fill: ${d};
    }
  `, s = t`
    ${({ theme: d }) => c(f(d.colors.darkGrey, 0.75))}
  `;
  if (r)
    return s;
  const p = t`
    ${({ theme: d }) => c(d.colors.white)}
  `, l = t`
    ${({ theme: d }) => c(d.colors.interface)}
  `, g = i === "white" ? u : k;
  if (n === "text" || n === "inline")
    return l;
  switch (e) {
    case "primary":
      return p;
    case "secondary":
      return l;
    case "tertiary":
      return t`
        ${c(g)}
      `;
  }
}, Z = W(/* @__PURE__ */ R.forwardRef(function({ href: e, children: n, className: r, shape: i, testId: c, disabled: s, target: p, onClick: l, onKeyDown: g, onKeyUp: d, onKeyPress: x, domProps: h }, y) {
  return i === "inline" ? /* @__PURE__ */ a.jsx("a", {
    className: r,
    "data-testid": c,
    href: e,
    target: p,
    onClick: l,
    onKeyDown: g,
    onKeyUp: d,
    onKeyPress: x,
    ref: y,
    ...h,
    children: n
  }) : /* @__PURE__ */ a.jsx("button", {
    className: r,
    "data-testid": c,
    onClick: l,
    onKeyDown: g,
    onKeyUp: d,
    onKeyPress: x,
    disabled: s,
    ref: y,
    ...h,
    children: n
  });
}))`
  ${X}
  ${H}

  ${({ variant: o = "primary", shape: e = "square", size: n = "small", sticky: r = !1, fullWidth: i = !1, mobile: c = !1, icon: s = void 0, disabled: p = !1, modifier: l = "white" }) => r ? t`
        ${B(r)}
        ${O(r, c)}
        ${C(o, e, r, l)}
      ` : e == "pagination" ? t`
        ${J(p)}
      ` : t`
      ${Y(o, e, l)}
      ${A(e)}
      ${N(n, e, o, !!s)}
      ${B(i)}
      ${C(o, e, r, l)}
      ${Q(!!s, o, e, p, l)}
    `}

  ${P}
`, cr = /* @__PURE__ */ R.forwardRef(function({ testId: e = "button", iconPosition: n = "left", sticky: r, loading: i, icon: c, size: s, shape: p, children: l, onClick: g, onKeyDown: d, onKeyPress: x, paginationDirection: h, onKeyUp: y, ...E }, I) {
  const L = () => h == "left" ? /* @__PURE__ */ a.jsx(j, {
    name: "back",
    size: 18,
    role: "img"
  }) : /* @__PURE__ */ a.jsx(j, {
    name: "forward",
    size: 18,
    role: "img"
  }), G = () => r && i ? /* @__PURE__ */ a.jsx(m, {
    size: "2rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    children: /* @__PURE__ */ a.jsx(M, {
      color: "white",
      strokeWidth: "5.5",
      size: "100%",
      showSpinnerBackground: !0
    })
  }) : p == "pagination" ? /* @__PURE__ */ a.jsx(m, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    children: L()
  }) : c ? /* @__PURE__ */ a.jsxs(m, {
    display: "flex",
    alignItems: "center",
    children: [
      n === "left" && /* @__PURE__ */ a.jsx(m, {
        size: "1.125rem",
        mr: s === "small" ? "0.5rem" : "0.75rem",
        testId: `${e}-icon-container`,
        children: c
      }),
      /* @__PURE__ */ a.jsx("span", {
        children: l
      }),
      n === "right" && /* @__PURE__ */ a.jsx(m, {
        size: "1.125rem",
        ml: s === "small" ? "0.5rem" : "0.75rem",
        testId: `${e}-icon-container`,
        children: c
      })
    ]
  }) : /* @__PURE__ */ a.jsx("span", {
    children: l
  }), T = (v) => {
    i || (p !== "inline" && _(v), g && g(v));
  };
  return /* @__PURE__ */ a.jsx(F, {
    children: /* @__PURE__ */ a.jsx(Z, {
      testId: e,
      icon: c,
      loading: i,
      size: s,
      shape: p,
      sticky: r,
      onClick: T,
      onKeyDown: d,
      onKeyUp: y,
      onKeyPress: x,
      ref: I,
      ...E,
      children: G()
    })
  });
}), _ = (o) => {
  o.stopPropagation();
  const e = o.currentTarget, n = document.createElement("span"), r = Math.max(e.clientWidth, e.clientHeight), i = r / 2;
  n.style.width = n.style.height = `${r}px`, n.style.left = `${o.clientX - (e.offsetLeft + i)}px`, n.style.top = `${o.clientY - (e.offsetTop + i)}px`, n.classList.add("ripple");
  const c = e.getElementsByClassName("ripple")[0];
  c && c.remove(), e.appendChild(n);
};
export {
  cr as Button
};
